/**
 * @generated SignedSource<<7daace8f267fe55d2b7f838342e406e3>>
 * @relayHash 96222d8226cccbd78f5bbac05a7fe1dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67de40a7489846e646fbd5606edbcde76d1fd205c03572b688229847230a7c41

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { modal_EnforceStorageLimitQuery } from './modal_EnforceStorageLimitQuery.graphql';

const node: PreloadableConcreteRequest<modal_EnforceStorageLimitQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "67de40a7489846e646fbd5606edbcde76d1fd205c03572b688229847230a7c41",
    "metadata": {},
    "name": "modal_EnforceStorageLimitQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
